//Style
import { ReactNode } from "react";
import classnames from "classnames"
import Styles from "./InlineSetting.module.scss";

interface InlineSettingProps{
    leftContent:string |ReactNode;
    rightContent:string | ReactNode;
    showDivider?:boolean;
}

const InlineSetting = ({leftContent,rightContent,showDivider=true}:InlineSettingProps) => {
  return (
    <div className={classnames(Styles.container,showDivider&&Styles.divider)}>
        <div className={Styles.title}>{leftContent}</div>
        <div className={Styles.right_container}>{rightContent}</div>
    </div>
  )
}

export default InlineSetting
